"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeSlots = exports.blocks = void 0;

var _imask = _interopRequireDefault(require("imask"));

var _moment = _interopRequireDefault(require("moment"));

var today = (0, _moment.default)();
var year = today.year();
var month = today.month();
var day = today.date();
var maxYear = today.add(150, "years").year();

var getTimeSlots = function getTimeSlots() {
  var startOfDay = (0, _moment.default)().startOf("day");
  var endOfDay = (0, _moment.default)().endOf("day");
  var timeArray = [];

  while (endOfDay.isSameOrAfter(startOfDay)) {
    timeArray.push({
      label: startOfDay.format("hh:mm A"),
      value: startOfDay.format("HH:mm")
    });
    startOfDay.add(30, "minutes");
  }

  return timeArray;
};

exports.getTimeSlots = getTimeSlots;

var blocks = function blocks() {
  var disablePast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    AP: {
      enum: ["AM", "PM"],
      mask: _imask.default.MaskedEnum
    },
    DD: {
      from: disablePast ? day : 1,
      mask: _imask.default.MaskedRange,
      to: 31
    },
    hh: {
      from: 1,
      mask: _imask.default.MaskedRange,
      to: 12
    },
    MM: {
      from: disablePast ? month : 1,
      mask: _imask.default.MaskedRange,
      to: 12
    },
    mm: {
      enum: ["00", "30"],
      mask: _imask.default.MaskedEnum
    },
    YYYY: {
      from: disablePast ? year : 1600,
      mask: _imask.default.MaskedRange,
      to: maxYear
    }
  };
};

exports.blocks = blocks;